<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A71QEI/tc-custom/9781558325678.jpg?1705007637251" alt="This image is the cover for the book Biker Billy's Hog Wild on a Harley Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Biker Billy's Hog Wild on a Harley Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <b>Cook up delicious dishes all day long with these recipes collected from Harley enthusiasts across America.</b><br/><br/>Harley-Davidson riders are a close-knit community that loves good food. The official motto of Harley riders may be “Live to Ride, Ride to Live,” but the unofficial motto is “Eat to Ride, Ride to Eat.”<br/><br/>To help celebrate the 100th anniversary of Harley-Davidson in 2003, Bill Hufnagle, aka Biker Billy, collected 200 righteous recipes from HOG (Harley Owners Group) members and other Harley enthusiasts from sea to shining sea whose close-second passion is a fantastic, stick-to-your-ribs meal with no holds barred. There are plenty of Billy’s own favorites included, too. Here and only here are recipes for Nana’s Famous Horseradish Cheese Spread, Grandpa’s Oil Can Stew, Penne with Crankcase Vodka Sauce, Black Leather Tostadas, and John’s Prison Break Cake. This is torqued-up-tasty food from a bunch of adventure-loving riders that’s certain to appeal to the more than five million Harley riders across the U.S.A.<br/><br/><b>Praise for <i>Biker Billy’s Hog Wild on a Harley Cookbook</i></b><br/><br/>“Whether you’re going cross-country on a Harley or a few blocks on a crosstown bus, Biker Billy takes you on a wild and hilarious road trip. These are the hottest recipes that this Wayne Harley has ever tested.” —Wayne Harley Brachman, author of <i>Retro Desserts</i> and host of the Food Network’s <i>Melting Pot</i><br/><br/>“Biker Billy has once again cooked up a fragrant collection of tales and recipes from the open road. All we need now is some tinfoil and a hot motor, and zesty meals will be served.” —J. Joshua Placa, editor of <i>Cruising Rider</i><br/><br/>“Despite the title’s appeal to a niche audience, Hufnagle has plenty of attractive recipes for all appetites to relish.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Hufnagle
      </h2>
      
      <p class="authorDescription body article">Bill Huffnagle is a columnist and the gastronomic editor for Cruising Rider magazine and the author of Biker Billy's Freway-a-Fire Cookbook and Biker Billy Cooks with Fire. When he's not riding his 1996 fuel-injected Harley-Davidson Road King Police Bike (FLHP-I) or his 2000 Buel S3T, Billy's in Asheville, North Carolina.www.bikerbilly.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38c9e8f0